import { useQuery } from "@tanstack/react-query";
import { AlertEvent } from "../../types";
import { alertEventsService } from "../../services/alertEventsService";

export const useAlertEvents = (alertId: string | undefined) => {
  return useQuery<AlertEvent[]>({
    queryKey: ["alert-events", alertId],
    enabled: !!alertId,
    queryFn: async () => {
      const r = await alertEventsService.list(alertId!);
      if(!r) {
        throw new Error(`Error retriving alert ${alertId}`);
      }
      return r;
    },
  });
};

